import { NativeBridge } from "./NativeBridge";
import { AndroidNativeBridge } from "./android";

class NativeModule {
  public module?: NativeBridge;

  public init(embedded: boolean) {
    if (embedded && "android" in window) {
      this.module = new AndroidNativeBridge();
    }
  }
}

const res = new NativeModule();
export { res as NativeModule };
